import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export const noTranslationMock = 'NO TRANSLATION'

export class LobbyMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        console.error('MISSING TRANSLATION: ', params)
        return noTranslationMock
    }
}